"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTouchScreen = exports.isIOS = void 0;

var _ssr = require("./ssr");

var isIOS = !_ssr.isSSR && /iPad|iPhone|iPod/.test(navigator.userAgent);
exports.isIOS = isIOS;
var isTouchScreen = !_ssr.isSSR && ('ontouchstart' in window || navigator.maxTouchPoints > 1);
exports.isTouchScreen = isTouchScreen;